/**
 * Утилита для управления событиями подсветки ошибок в форме отгрузки
 */

const SHIPMENT_ERROR_EVENT = 'shipment-form-error';

/**
 * Вызывает подсветку ошибок в форме отгрузки
 */
export const triggerShipmentFormError = (): void => {
  const event = new CustomEvent(SHIPMENT_ERROR_EVENT);
  window.dispatchEvent(event);
};

/**
 * Подписка на событие подсветки ошибок
 * @param callback - функция, которая будет вызвана при срабатывании события
 * @returns функция для отписки от события
 */
export const onShipmentFormError = (callback: () => void): (() => void) => {
  window.addEventListener(SHIPMENT_ERROR_EVENT, callback);
  return () => {
    window.removeEventListener(SHIPMENT_ERROR_EVENT, callback);
  };
};
